/**
 * Template: Search
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality
 *
 * @namespace search
 */
import 'url-search-params-polyfill';

import {on} from '../helpers/utils';
import Quickview from '../components/quickview';


/**
 * DOM selectors.
 */
const selectors = {
  sortSelector: '[js-collection="sortBy"]',
  cardGrid: '[js-card-grid]',
  gridSelector: '[js-grid-selector]',
};

/**
 * Create a new sort by filter.
 */
const sortByFilter = () => {

  /**
   * Node selectors.
   */
  const selectMenu = document.querySelector(selectors.sortSelector);
  const searchParams = new URLSearchParams(window.location.search);
  const cardGrid = document.querySelector(selectors.cardGrid);
  const gridSelectors = document.querySelectorAll(selectors.gridSelector);

  /**
   * Initialise sort by component.
   */
  function init() {
    setSelectEvents();
    setQuickviewEvents();

    if (window.location.search) {
      updateSortBy();
    }

    setClickEvents();
  }

  /**
   * Set click events on Grid Selector.
   */
  function setClickEvents() {
    gridSelectors.forEach((el) => {
      on('click', el, () => {
        el.classList.add('active');

        const gridData = el.getAttribute('js-grid-selector');
        if (gridData === 'two') {
          const gridThreeSelector = document.querySelector('[js-grid-selector="three"]');
          gridThreeSelector.classList.remove('active');
          setCardGridTwo();
        } else if (gridData === 'three') {
          const gridTwoSelector = document.querySelector('[js-grid-selector="two"]');
          gridTwoSelector.classList.remove('active');
          setCardGridThree();
        }
      });
    });
  }

  /**
   * Switch Card Grid to Two Columns
   */
  function setCardGridTwo() {
    cardGrid.classList.remove('card-grid--3up');
  }

  /**
   * Switch Card Grid to Three Columns
   */
  function setCardGridThree() {
    cardGrid.classList.add('card-grid--3up');
  }

  /**
   * Set sort by select events.
   */
  function setSelectEvents() {
    on('change', selectMenu, (event) => handleChangeEvent(event));
  }

  /**
   * Handle event from select menu.
   * @param {Event} event - Change event.
   */
  function handleChangeEvent(event) {
    event.preventDefault();

    const newSearchParams = new URLSearchParams();
    newSearchParams.set(event.currentTarget.name, event.currentTarget.value);
    window.location = `${window.location.origin}${window.location.pathname}?sort_by${newSearchParams}`;
  }

  /**
   * Update default state of selector by using selectedIndex.
   */
  function updateSortBy() {
    if (selectMenu) {
      selectMenu.options.selectedIndex = getSelectedOption().index;
    }
  }

  /**
   * Get selected option from search parameters in URL string.
   */
  function getSelectedOption() {
    return [...selectMenu.options].filter((element) => {
      return (element.value.match(searchParams.get('sort_by')));
    })[0];
  }

  /**
   * Set quickview event listeners on buttons.
   */
  function setQuickviewEvents() {
    Quickview().init();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};

/**
 * Instantiate collection modules.
 */
sortByFilter().init();
